class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
    this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  get hoverEnabled() {
    return this.hoverMediaQuery.matches;
  }

  onHoverEnter() {
    if (!this.hoverEnabled) return;

    clearTimeout(this.closeTimeout);
    this.closeSiblings();
    this.open();
  }

  onHoverLeave() {
    if (!this.hoverEnabled) return;

    // Small delay so moving the pointer from the summary to the submenu
    // (which crosses a gap that is outside this element) does not close it.
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.close(), 150);
  }

  // The parent item is a real link: let the click through so it navigates.
  // Otherwise the pointer controls the menu on desktop, so a mouse click on the
  // summary must not toggle it shut. Keyboard activation (detail === 0) still toggles.
  onSummaryClick(event) {
    if (event.target.closest('.header__menu-parent-link')) return;
    if (this.hoverEnabled && event.detail > 0) event.preventDefault();
  }

  closeSiblings() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });
  }

  open() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    clearTimeout(this.closeTimeout);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
